export default class Tag {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/Tag.ts